import React, { FC } from 'react'
import { CardCollectionProps } from './CardCollection.types'
import './CardCollection.module.scss'
import {
  getValueListBackgroundColorFromFillColor,
  getValueListBgColor,
  getValueListTextColorFromFillColor,
} from '../../../../utils/background-util'
import { LinkCompound } from '../../../Compounds/src/LinkCompound'
import { RTECompound } from '../../../Compounds/src/RTECompound'
import { BrandIcon } from '../../../Compounds/src/BrandIconCompound'
import { CardCollectionsTemplateProps } from '../../CardCollectionsTemplateProps.types'
import { setBgContrastClass, setConfigBgColorClass } from '../../../../utils/layout-util'

export const CardCollection: FC<CardCollectionProps> = props => {
  const {
    cardCollectionList,
    noOfColumns = '3',
    componentSpacing,
    layoutConfigs,
    brandExtension,
    cardDescription,
  } = props
  const colSize = layoutConfigs?.columnSize ? `u-size${layoutConfigs?.columnSize}` : ''
  const backgroundColor = setConfigBgColorClass(layoutConfigs)
  const setBackgroundColor = backgroundColor
    ? `${backgroundColor} ${setBgContrastClass(layoutConfigs)} `
    : 'noBgColor'
  return (
    <section className={`card-collection-component ${componentSpacing} ${setBackgroundColor}`}>
      {cardDescription && (
        <div className='Grid Grid--alignCenter u-paddingBottom40 card-collection-header u-sizeConstrained'>
          <RTECompound content={cardDescription} />
        </div>
      )}
      <div
        className={`Grid Grid--withGutter u-sizeConstrained u-flex u-sm-flexCol ${colSize} ${brandExtension}`}>
        {cardCollectionList?.map((card, index) => (
          <div
            key={card.heading}
            className={`${noOfColumns === '2' ? 'u-size1of2' : 'u-size1of3'} u-sm-sizeFull u-flex`}>
            <div
              className={`u-paddingVert32 u-paddingHoriz20 card-border ${getValueListBgColor(
                card.backgroundColor ?? 'white'
              )} u-marginBottom20 u-sm-marginRight0 u-sizeFull`}>
              {card.icon ? (
                <BrandIcon
                  iconsDropdown={card.icon.iconsDropdown}
                  iconsColorsDropdown={card.borderColor ?? 'u-fillAmpfBlue'}
                  alignment={card.icon.alignment}
                  enableBorder={false}
                  size={'u-sizeDefault'}
                  identifier={card.icon.identifier}
                />
              ) : (
                card.superHeadline && (
                  <div className='u-paddingBottom8'>
                    <h1
                      className={`${
                        card.template === CardCollectionsTemplateProps.Card_Footer
                          ? getValueListTextColorFromFillColor(
                              card.borderColor ?? 'u-fillColorNeutral'
                            )
                          : ''
                      }`}>
                      {card.superHeadline}
                    </h1>
                  </div>
                )
              )}
              {card.heading && (
                <div className='u-paddingBottom8'>
                  {card.cardHeadingLevel === 'h3' ? (
                    <h3
                      className={`${
                        card.template === CardCollectionsTemplateProps.Card_Footer
                          ? getValueListTextColorFromFillColor(
                              card.borderColor ?? 'u-fillColorNeutral'
                            )
                          : ''
                      }`}>
                      <strong>{card.heading}</strong>
                    </h3>
                  ) : (
                    <h4
                      className={`${
                        card.template === CardCollectionsTemplateProps.Card_Footer
                          ? getValueListTextColorFromFillColor(
                              card.borderColor ?? 'u-fillColorNeutral'
                            )
                          : ''
                      }`}>
                      <strong>{card.heading}</strong>
                    </h4>
                  )}
                </div>
              )}
              {card.cardDescription?.content && (
                <RTECompound content={card.cardDescription?.content} />
              )}
              {card.link?.text && (
                <LinkCompound
                  type='secondary-button'
                  classes={[
                    'u-marginTop32 u-textColorActionBlue Button--secondary Button--secondary--action-blue',
                  ]}
                  href={card.link?.href}
                  data-analytics={card.link?.analytics}
                  text={card.link?.text}
                  linkAltText={card?.link?.linkAltText || ''}
                />
              )}
              {card.template === CardCollectionsTemplateProps.Card_Footer && (
                <div
                  className={`card-footer ${
                    card.borderColor
                      ? getValueListBackgroundColorFromFillColor(
                          card.borderColor ?? 'u-fillColorWhite'
                        )
                      : ''
                  }`}></div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
